export class EmailTemplate {
  id:number;
  name: string;
  subject: string;
  message: string;
  created_date:string;

  deserialize(input: any): this {
    return Object.assign(this, input);
  }
}
